'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '../contexts/AuthContext';
import HomePage from './home/page';

export default function RootPage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    // Check for Supabase password reset code in URL
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams?.get('code');

    if (code) {
      router?.replace(`/reset-password?code=${code}`);
      return;
    }

    if (!loading && user) {
      router?.replace('/main-dashboard');
    }
  }, [user, loading, router]);

  // If user is confirmed logged in, show redirecting spinner
  if (!loading && user) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-slate-400 text-sm">Redirecting...</p>
        </div>
      </div>
    );
  }

  // Show home page immediately for unauthenticated users (and during loading)
  return <HomePage />;
}
